module.exports = __webpack_public_path__ + "static/img/report_img_xxxmfxpgbg.7cf102a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_xxxmfxpgbg.png
// module id = VXrV
// module chunks = 21